import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCustomToast } from '@nexelem/snackbar';
import { useAPI } from '@nexelem/api';
import { useCustomTranslation } from '../../../../hooks';
import { productTechnologiesListQueryKey } from './useProductTechnologiesList';

export const useDeactivateTechnology = (variantId: number, name: string) => {
  const api = useAPI();
  const queryClient = useQueryClient();
  const displayToast = useCustomToast();
  const { tWrapper } = useCustomTranslation('products.detailsPage.technology');

  return useMutation({
    mutationFn: (techId: number) => api.deleteBackSpecificationsTemplateDeactivateP1({ p1: techId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: productTechnologiesListQueryKey(variantId) });
      displayToast({
        toastType: 'info',
        message: tWrapper('toast.deactivated', { name }),
      });
    },
    onError: () => {
      displayToast({ toastType: 'error', message: tWrapper('toast.deactivationError') });
    },
  });
};
